import { useState } from "react";

interface AbstractTabsProps {
  es: string;
  en: string;
}

export default function AbstractTabs({ es, en }: AbstractTabsProps) {
  const [lang, setLang] = useState<"es" | "en">("es");

  return (
    <div>
      {/* Tab buttons */}
      <div className="flex border-b border-[var(--border)] mb-4">
        <button
          className={`abstract-tab ${lang === "es" ? "active" : ""}`}
          onClick={() => setLang("es")}
        >
          Español
        </button>
        <button
          className={`abstract-tab ${lang === "en" ? "active" : ""}`}
          onClick={() => setLang("en")}
        >
          English
        </button>
      </div>

      {/* Content */}
      <p
        className="text-gray-700 leading-relaxed text-base"
        style={{ fontFamily: "var(--font-serif)", fontSize: "1.05rem" }}
      >
        {lang === "es" ? es : en}
      </p>
    </div>
  );
}
